import { gql } from '@apollo/client';
import React from 'react';
import type { ReactionThreadCompact_ThreadFragment } from '../../graphql/generated/graphqlTypes';
import showFullPageSheet from './showFullPageSheet';
import ReactionAvatarStack from './ReactionAvatarStack';
import { usePostLayoutSize } from '../PostLayoutSizeContext';
import { isFeatureEnabled } from '../../utils/features';

const THREAD_FRAGMENT = gql`
  fragment ReactionThreadCompact_thread on PublicThreadFields {
    id
    reactions {
      id
      ...ReactionAvatarStack_reaction
    }
  }
  ${ReactionAvatarStack.fragments.reaction}
`;

interface ReactionThreadCompactProps {
  thread: ReactionThreadCompact_ThreadFragment;
  isFocused: boolean;
}

const ReactionThreadCompact = ({
  thread,
  isFocused,
}: ReactionThreadCompactProps) => {
  const postLayoutSize = usePostLayoutSize();
  const isNarrow = ['mobile', 'narrow'].includes(postLayoutSize);

  const avatarStackItems = thread.reactions;

  const hasRing = isFocused && showFullPageSheet();

  return (
    <ReactionAvatarStack
      maxItemsShown={3}
      reactions={
        isNarrow && !isFeatureEnabled('new_post_layout')
          ? avatarStackItems.slice(0, 1)
          : avatarStackItems
      }
      ring={hasRing}
    />
  );
};

ReactionThreadCompact.fragments = { thread: THREAD_FRAGMENT };

export default ReactionThreadCompact;
